import { Injectable } from '@angular/core';
import { Cmsma } from './Cmsma-angular';
import { JkEntityV2 } from './jkEntityV2';
import { dateFormatter } from './ag-grid.service';
import { EntityType } from './jkEntityTypes';


@Injectable({
  providedIn: 'root'
})
export class CmsmaServicePkg extends JkEntityV2 {


  constructor() {
    super();
    this.linkMasterFields = '';
    this.defaultItem = new Cmsma();
    this.entityType.type = EntityType.data;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      MA001: '日期格式', MA002: '日期區隔符號', MA003: '本國幣別', MA004: '營業稅率(%)', MA005: 'MRP使用NetChang', MA006: '稅額', MA007: '商品分類方式一', MA008: '商品分類方式二', MA009: '商品分類方式三', MA010: '商品分類方式四', MA011: '庫存現行年月', MA012: '庫存關帳年月', MA013: '帳務凍結日期', MA014: '成本計價方式', MA015: '會計現行期別', MA016: '會計期制', MA017: '更新低階碼', MA018: '會計關帳期別', MA019: '會計現行年度', MA020: '會計關帳年度', MA021: '銀行存款現行年月', MA022: '計薪年月', MA023: '一品號對應多條碼', MA024: '數量表達方式', MA025: '確認日依據', MA026: '產品功能別', MA027: '應收現行年月', MA028: '應收關帳年月', MA029: '應付現行年月', MA030: '應付關帳年月', MA031: '數值欄位三位一撇', MA032: '執行電子表單流程'
    };

    this.fieldNames = 'MA001,MA002,MA003,MA004,MA005,MA006,MA007,MA008,MA009,MA010,MA011,MA012,MA013,MA014,MA015,MA016,MA017,MA018,MA019,MA020,MA021,MA022,MA023,MA024,MA025,MA026,MA027,MA028,MA029,MA030,MA031,MA032';
    this.fieldLengths = { MA001: 1, MA002: 1, MA003: 4, MA004: 5.4, MA005: 1, MA006: 1, MA007: 10, MA008: 10, MA009: 10, MA010: 10, MA011: 6, MA012: 6, MA013: 8, MA014: 1, MA015: 2, MA016: 1, MA017: 6, MA018: 2, MA019: 4, MA020: 4, MA021: 6, MA022: 6, MA023: 1, MA024: 1, MA025: 1, MA026: 1, MA027: 6, MA028: 6, MA029: 6, MA030: 6, MA031: 1, MA032: 1 };
    this.columnDefs = [
      { field: "MA025", headerName: "確認日依據", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "MA018", headerName: "會計關帳期別", headerTooltip: "", width: 86, cellDataType: "text", },
      { field: "MA019", headerName: "會計現行年度", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "MA020", headerName: "會計關帳年度", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "MA021", headerName: "銀行存款現行年月", headerTooltip: "", width: 118, cellDataType: "text", },
      { field: "MA022", headerName: "計薪年月", headerTooltip: "", width: 118, cellDataType: "text", },
      { field: "MA023", headerName: "一品號對應多條碼", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "MA024", headerName: "數量表達方式", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "MA017", headerName: "更新低階碼", headerTooltip: "", width: 118, cellDataType: "text", },
      { field: "MA026", headerName: "產品功能別", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "MA027", headerName: "應收現行年月", headerTooltip: "", width: 118, cellDataType: "text", },
      { field: "MA028", headerName: "應收關帳年月", headerTooltip: "", width: 118, cellDataType: "text", },
      { field: "MA029", headerName: "應付現行年月", headerTooltip: "", width: 118, cellDataType: "text", },
      { field: "MA030", headerName: "應付關帳年月", headerTooltip: "", width: 118, cellDataType: "text", },
      { field: "MA031", headerName: "數值欄位三位一撇", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "MA032", headerName: "執行電子表單流程", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "MA001", headerName: "日期格式", headerTooltip: "", width: 120, cellDataType: "text", },
      { field: "MA008", headerName: "商品分類方式二", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "MA002", headerName: "日期區隔符號", headerTooltip: "", width: 120, cellDataType: "text", },
      { field: "MA003", headerName: "本國幣別", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "MA004", headerName: "營業稅率(%)", headerTooltip: "", width: 113, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "MA005", headerName: "MRP使用NetChang", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "MA006", headerName: "稅額", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "MA007", headerName: "商品分類方式一", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "MA016", headerName: "會計期制", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "MA009", headerName: "商品分類方式三", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "MA010", headerName: "商品分類方式四", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "MA011", headerName: "庫存現行年月", headerTooltip: "", width: 118, cellDataType: "text", },
      { field: "MA012", headerName: "庫存關帳年月", headerTooltip: "", width: 118, cellDataType: "text", },
      { field: "MA013", headerName: "帳務凍結日期", headerTooltip: "", width: 120, cellDataType: "text", valueFormatter: dateFormatter, },
      { field: "MA014", headerName: "成本計價方式", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "MA015", headerName: "會計現行期別", headerTooltip: "", width: 86, cellDataType: "text", },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'CMSMA';
    this.isSys = false;
    this.sqlSelect = `SELECT CMSMA.*  FROM CMSMA`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY MA001`;
    this.keyFields = ['MA001'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['MA001'];
    this.seqField = '';
    this.seqFieldLength = 0;
  }
  override async validateItem(item: Cmsma): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

  override async newRecord(newItem: Cmsma): Promise<Cmsma> {
    await super.newRecord(newItem);
    return newItem;
  }




}

